<template>
<div class="chapter">
<div class="inner_page">
<div id="fm11">
<p class="heading"><span class="bold">CONTENTS</span></p>
<p class="cont"><span href="#/Acknowledgement#fm8" title="Link target outside of Sample">Acknowledgement</span></p>
<p class="cont"><a href="#/Prologue#fm10">Prologue</a></p>
<p class="cont"><a href="#/Part_01#ch1">PART ONE</a></p>
<p class="cont"><span href="#/Part_02#ch2" title="Link target outside of Sample">PART TWO</span></p>
<p class="cont"><span href="#/Part_03#ch3" title="Link target outside of Sample">PART THREE</span></p>
<p class="cont"><span href="#/Epilogue#bm1" title="Link target outside of Sample">Epilogue</span></p>
<p class="cont"><span href="#/Author_notes#bm2" title="Link target outside of Sample">Author’s Notes</span></p>
<p class="cont"><span href="#/Biblography#bm3" title="Link target outside of Sample">Biblography</span></p>
<p class="cont"><span href="#/About_the_author#bm4" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?664e4fd4